"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRadioContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _fontIcon = _interopRequireDefault(require("../font-icon"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _radioComponents = require("./_radio-components");

var _versions = require("../../_utils/versions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getIcon = function getIcon(props) {
  var version = props.version,
      icon = props.icon;
  return _react["default"].createElement(_fontIcon["default"], {
    version: version
  }, icon);
};

var getCheckMark = function getCheckMark(props) {
  var checked = props.checked,
      version = props.version,
      shadowOnHover = props.shadowOnHover;
  return _react["default"].createElement(_radioComponents.Checkmark, {
    checked: checked,
    version: version,
    tabIndex: 0,
    shadowOnHover: shadowOnHover
  });
};

var getBox = function getBox(props) {
  var checked = props.checked,
      value = props.value,
      readOnly = props.readOnly,
      version = props.version;
  return _react["default"].createElement(_radioComponents.Box, {
    type: "radio",
    checked: checked,
    value: value,
    readOnly: readOnly,
    version: version,
    tabIndex: -1
  });
};

var getRadioLabel = function getRadioLabel(props) {
  var checked = props.checked,
      version = props.version,
      type = props.type,
      spaceBetween = props.spaceBetween,
      label = props.label;
  return _react["default"].createElement(_radioComponents.RadioLabel, {
    checked: checked,
    version: version,
    type: type,
    spaceBetween: spaceBetween
  }, label);
};

var getButton = function getButton(props) {
  var checked = props.checked,
      version = props.version,
      spaceBetween = props.spaceBetween,
      activeColor = props.activeColor,
      activeBorderColor = props.activeBorderColor,
      icon = props.icon,
      noSpace = props.noSpace,
      text = props.text,
      activeTextColor = props.activeTextColor;
  return _react["default"].createElement(_radioComponents.Button, {
    checked: checked,
    version: version,
    width: "initial",
    spaceBetween: spaceBetween,
    noSpace: noSpace,
    text: text,
    activeColor: (0, _versions.getSpecificColor)(props, activeColor),
    activeBorderColor: (0, _versions.getSpecificColor)(props, activeBorderColor),
    activeTextColor: (0, _versions.getSpecificColor)(props, activeTextColor)
  }, icon && getIcon(props), text);
};

var getContent = function getContent(props, buttonOrBadge) {
  if (buttonOrBadge) {
    var content = [getBox(props), getButton(props)];

    if (props.label) {
      content.push(getRadioLabel(props));
    }

    return content;
  } else {
    var _content = [getBox(props), getCheckMark(props)];

    if (props.icon) {
      _content.push(_react["default"].createElement(_fontIcon["default"], null, props.icon));
    }

    if (props.label) {
      _content.push(getRadioLabel(props));
    }

    return _content;
  }
};

var getRadioContent = function getRadioContent(props, buttonOrBadge) {
  if (props.tooltip && props.tooltip.content) {
    return _react["default"].createElement(_tooltip["default"], _extends({}, props.tooltip, {
      version: props.version
    }), getContent(props, buttonOrBadge));
  }

  return getContent(props, buttonOrBadge);
};

exports.getRadioContent = getRadioContent;